// Re-export store and analytics for backward compatibility.
// Payment components can import directly from stores/paymentStore and services/analytics.
export {
    stripeGlobal,
    stripeShared,
    setStripeKey,
    paymentStore,
    usePaymentStore,
    solidgateApplePayContainerRef,
    solidgateGooglePayContainerRef,
} from '../../../stores/paymentStore';

export { sendFBInitiateCheckout as logFBInitiateCheckout } from '../../../services/api';

import { trackPurchaseCompleted } from '../../../services/analytics';

export function logPurchaseCompletedSuccess(onboardingId, priceID, discountID, price, urlParams, email) {
    trackPurchaseCompleted({ onboardingId, priceID, discountID, price, email });
}
